import { Box, Skeleton } from '@mui/material';

export function CategorySectionTitleSkeleton() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginBottom: 3 }}>
      <Skeleton variant="rounded" sx={{ width: 250, height: 20 }} />
      <Skeleton variant="rounded" sx={{ width: '100%', height: 30 }} />
    </Box>
  );
}
